import { all, fork } from "redux-saga/effects"

//public
// import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
// import ForgetSaga from "./auth/forgetpwd/saga"
// import ProfileSaga from "./auth/profile/saga"

// import CustomerSaga from "./customer/saga"
import LayoutSaga from "./layout/saga"

//Settlement
import SettlementSaga from "./settlement/saga"
// import paymentrequestsSaga from "./paymentrequests/saga"
// import paymentResponsesSaga from "./paymentresponse/saga"
// import ItemsSaga from "./items/saga"
// import MerchantSaga from "./merchant/saga"
// import UserSaga from "./user/saga"
// import PayGateSaga from "./paymentgateway/saga"
// import LogsSaga from "./logs/saga"
// import PaymentHistory from "./paymenthistory/saga"
// import DashboardSaga from "./dashboard/saga"
// import MainSearch from "./search/saga"
// import Settlement from "./settlement/saga"
import customerConfigurationSaga from "./customerconfigurations/saga"
import incentiveDueCalcualtionSaga from "./incentiveduecalculations/saga"
import OtherChargesSaga from "./othercharges/saga"
import customersSaga from "./customer/saga"
import optionsSaga from "./options/saga"
import productListSaga from "./products/saga"


export default function* rootSaga() {
  yield all([
    //public
    // ForgetSaga(),
    // LayoutSaga(),
    // PaymentHistory(),
    // CustomerSaga(),
    // ItemsSaga(),
    // MerchantSaga(),
    // paymentrequestsSaga(),
    // paymentResponsesSaga(),
    // UserSaga(),
    // PayGateSaga(),
    // LogsSaga(),
    // DashboardSaga(),
    // MainSearch(),
    // Settlement(),
    fork(AuthSaga),
    LayoutSaga(),
    SettlementSaga(),
    OtherChargesSaga(),
    customerConfigurationSaga(),
    incentiveDueCalcualtionSaga(),
    customersSaga(),
    optionsSaga(),
    productListSaga()
  ])
}
